import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import ApiService from '../api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import { PaymentAccount } from '@pulpo/pulpo-models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentAccountService extends ApiService<PaymentAccount> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'payment/api/account');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8091';
    }
  }

  updateByAgencyUserGroupId(
    agencyUserGroupId: string,
    body: Partial<PaymentAccount>
  ): Observable<HttpResponse<PaymentAccount>> {
    return this.http.put<PaymentAccount>(
      `${this.url}/${this.endpoint}/${agencyUserGroupId}`,
      body,
      { observe: 'response' }
    );
  }
}
